var _excluded = ["externalImage", "externalImageAlt", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import Box from '../box';
import ResponsiveLazyImage from '../lazy-image';
import styles from './styles.module.scss';
import classNames from 'classnames';

var ExternalOrLazyImage = function ExternalOrLazyImage(_ref) {
  var externalImage = _ref.externalImage,
      externalImageAlt = _ref.externalImageAlt,
      className = _ref.className,
      responsiveLazyImageProps = _objectWithoutProperties(_ref, _excluded);

  return externalImage ? /*#__PURE__*/React.createElement(Box, {
    desktopDisplay: "block",
    mobileDisplay: "block",
    tabletDisplay: "block",
    fullHeight: true,
    className: ""
  }, /*#__PURE__*/React.createElement("img", {
    alt: externalImageAlt || '',
    className: classNames(className, styles.externalImage),
    "data-testid": "test-external-image",
    src: externalImage
  })) : /*#__PURE__*/React.createElement(ResponsiveLazyImage, _extends({
    className: className
  }, responsiveLazyImageProps));
};

export default ExternalOrLazyImage;